import { useEffect, useState } from "react"

import { FieldData, mapFilters } from "@/components/_Shared/FilterWrapper"

import { useRequestQuoteStatusesQuery } from "@/hook/BulkOrders/useRequestQuoteStatusesQuery"
import { useCustomersSelectListQuery } from "@/hook/Dictionaries/Customers/useCustomerQuery"
import { useDepotQuery } from "@/hook/Dictionaries/useDepotQuery"
import { useFuelTypeQuery } from "@/hook/Dictionaries/useFuelTypeQuery"
import { useFilterStorage } from "@/hook/useFilterStorage"

import { PERSONAL_OFFER_KEY } from "@/types/IBulkOrder"
import { FilterField, FilterFieldType } from "@/types/ui"

export const usePersonalOffersFilters = () => {
    const [filters, setFilters] = useState<FilterField[]>([])

    const { getFilter } = useFilterStorage({
        key: PERSONAL_OFFER_KEY
    })

    const oldFilters: FieldData[] = getFilter()

    const { data: customers } = useCustomersSelectListQuery()
    const { data: statuses } = useRequestQuoteStatusesQuery()
    const { data: depots } = useDepotQuery()
    const { data: fuelTypes } = useFuelTypeQuery()

    useEffect(() => {
        setFilters([
            {
                text: "Год",
                name: "Year",
                type: FilterFieldType.Text
            },
            {
              text: "Статус",
              name: "Status",
              type: FilterFieldType.MultiSelect,
              values: statuses,
              hidden: false
            },
            {
              text: "Контрагент",
              name: "CustomerId",
              type: FilterFieldType.MultiSelect,
              values: customers?.response.map((c) => ({
                id: c.value,
                name: c.label
              })),
              hidden: false
            },
            {
              text: "Нефтебаза",
              name: "DepotId",
              type: FilterFieldType.Select,
              values: depots?.response.data
            },
            {
              text: "Тип топлива",
              name: "FuelTypeId",
              type: FilterFieldType.Select,
              values: fuelTypes?.response.data
            }
        ])
    }, [statuses, customers, depots, fuelTypes])

    return mapFilters(filters, oldFilters)
}
